import React from 'react'
import { NavLink } from 'react-router-dom'

function MobileNav() {
  return (
    <div className='mobile-header'>
      <button
        className='btn'
        type='button'
        data-bs-toggle='collapse'
        data-bs-target='#collapse-nav'
        aria-expanded='false'
        aria-controls='collapse-nav'>
        <i className='fas fa-bars text-light'></i>
      </button>
      <div className='collapse' id='collapse-nav'>
        <ul className='navbar-nav ms-auto'>
          <li className='nav-item '>
            <NavLink className='nav-link px-2' exact to='/'>
              <span className='ms-2'>
                <i className='fas fa-plus me-2'></i>
                Create Badge
              </span>
            </NavLink>
          </li>
          <li className='nav-item  mt-3'>
            <NavLink
              className='nav-link px-2'
              exact
              to={{
                pathname: '/issue',
                state: {
                  badgeName: '',
                },
              }}>
              <span className='ms-2'>
                <i className='fas fa-upload me-2'></i>Issue Badge
              </span>
            </NavLink>
          </li>
          <li className='nav-item  mt-3'>
            <NavLink className='nav-link px-2' exact to='/all-badges'>
              <span className='ms-2'>
                <i className='fas fa-user me-2'></i>All Badges
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default MobileNav
